import Tag from './Tag';
export { TagSize, TagVariant } from './constants';
export * from './Tag';
export default Tag;
